module.exports = __webpack_public_path__ + "media/mccormick-poster.096c5818.webm";